// Glow Tic-Tac-Toe 3x3 Server Engine (2 Players)
export class TicTacToeEngine {
  constructor(io, room) {
    this.io = io;
    this.room = room;
    this.board = Array(9).fill(null); // 0-8
    this.playerX = null;
    this.playerO = null;
    this.currentTurn = 'X';
    this.winner = null;
  }

  start() {
    this.board = Array(9).fill(null);
    this.playerX = this.room.players[0] || null;
    this.playerO = this.room.players[1] || null;

    if (!this.playerO && this.room.settings?.fillBots !== false) {
      this.playerO = { id: 'bot_ttt', name: '🤖 NeonBot', isBot: true };
    }

    this.currentTurn = 'X';
    this.winner = null;

    this.io.to(this.room.code).emit('ttt_started', {
      playerX: this.playerX,
      playerO: this.playerO,
      currentTurn: this.currentTurn,
      board: this.board
    });
  }

  checkBotTurn() {
    if (this.winner || this.currentTurn !== 'O' || !this.playerO?.isBot) return;

    setTimeout(() => {
      if (this.winner || this.currentTurn !== 'O') return;
      const available = [];
      for (let i = 0; i < 9; i++) {
        if (!this.board[i]) available.push(i);
      }
      if (available.length === 0) return;

      let chosen = available[Math.floor(Math.random() * available.length)];
      for (const idx of available) {
        this.board[idx] = 'O';
        if (this.checkWin('O')) { chosen = idx; this.board[idx] = null; break; }
        this.board[idx] = null;
      }
      for (const idx of available) {
        this.board[idx] = 'X';
        if (this.checkWin('X')) { chosen = idx; this.board[idx] = null; break; }
        this.board[idx] = null;
      }
      if (available.includes(4)) chosen = 4;
      this.makeMove(this.playerO.id, chosen);
    }, 500);
  }

  makeMove(playerId, cellIndex) {
    if (this.winner || cellIndex < 0 || cellIndex > 8 || this.board[cellIndex]) return;

    const isX = this.playerX && this.playerX.id === playerId;
    const isO = this.playerO && this.playerO.id === playerId;

    if ((this.currentTurn === 'X' && !isX) || (this.currentTurn === 'O' && !isO)) {
      return; // Not your turn
    }

    const mark = this.currentTurn;
    this.board[cellIndex] = mark;

    const winCombo = this.checkWin(mark);

    this.io.to(this.room.code).emit('ttt_moveMade', {
      cellIndex,
      mark,
      board: this.board,
      currentTurn: this.currentTurn === 'X' ? 'O' : 'X',
      winCombo
    });

    if (winCombo) {
      this.winner = mark === 'X' ? this.playerX : this.playerO;
      this.io.to(this.room.code).emit('ttt_gameOver', { winner: this.winner, winCombo });
    } else if (this.board.every((c) => c !== null)) {
      this.io.to(this.room.code).emit('ttt_gameOver', { winner: null, isDraw: true });
    } else {
      this.currentTurn = this.currentTurn === 'X' ? 'O' : 'X';
      this.checkBotTurn();
    }
  }

  checkWin(m) {
    const lines = [
      [0, 1, 2], [3, 4, 5], [6, 7, 8], // Rows
      [0, 3, 6], [1, 4, 7], [2, 5, 8], // Cols
      [0, 4, 8], [2, 4, 6]             // Diagonals
    ];
    return lines.find(([a, b, c]) => this.board[a] === m && this.board[b] === m && this.board[c] === m) || null;
  }

  destroy() {}
}
